import { LOGO_URL } from "../lib/constants";
import { Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B192C] text-white mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img
              src={LOGO_URL}
              alt="Car Hurt Help"
              className="h-10 w-10 rounded-md object-cover bg-[#0B192C]"
            />
            <span className="font-display text-xl font-bold">Car Hurt Help</span>
          </div>
          <p className="text-sm text-slate-300 max-w-xs">
            You were in an accident. We're here to help.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-3">
            How it works
          </div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li>1. Confirm you were not at fault</li>
            <li>2. Share accident details</li>
            <li>3. Our team reaches out to help</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-3">
            Privacy
          </div>
          <p className="text-sm text-slate-300 flex items-start gap-2">
            <Lock className="h-4 w-4 mt-0.5 text-slate-400" />
            Your information is encrypted in transit and only shared with
            authorized Car Hurt Help staff.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-400">
          <span>© {new Date().getFullYear()} Car Hurt Help. All rights reserved.</span>
          <span>Not a law firm. Not legal advice. Intake services only.</span>
        </div>
      </div>
    </footer>
  );
}
